import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import _size from 'lodash/size';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import withFormPageState from '../../connectors/withFormPageState';
import FormPage from '../../pages/formPage';
import Button from '../../atoms/Button';
import { getFormSections, getFormFields } from './multiSort.config';
import { ACTION_HANDLERS } from './multiSort.actionHandlers';
import { FIELD_NAMES } from './multiSort.constants';
import { INIT_FORM, RESET_FORM_FIELDS } from './multiSort.actions';
import styles from './multiSort.module.scss';
var MultiSort = function MultiSort(props) {
  var onAction = props.onAction,
    _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$errors = props.errors,
    errors = _props$errors === void 0 ? {} : _props$errors,
    allColumns = props.allColumns,
    onClose = props.onClose;
  useEffect(function () {
    onAction({
      type: INIT_FORM
    });
  }, []);
  var onCancelHandler = function onCancelHandler() {
    onAction({
      type: RESET_FORM_FIELDS
    });
  };
  var footerProps = useMemo(function () {
    var isTertiaryDisabled = _size(values[FIELD_NAMES.SORT_PREFERENCES]) <= 1;
    return {
      primaryButtonLabel: __('Apply'),
      showSecondaryButton: false,
      showTertiaryButton: true,
      tertiaryActionView: Button.VIEW.TERTIARY,
      tertiaryButtonLabel: __('Reset'),
      containerClassName: styles.footerContainer,
      isTertiaryDisabled: isTertiaryDisabled,
      onTertiaryAction: onCancelHandler
    };
  }, [onCancelHandler, values]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    view: Button.VIEW.TERTIARY,
    className: styles.closeButton,
    onClick: onClose,
    icon: "icon-close"
  }), /*#__PURE__*/React.createElement(FormPage, {
    values: values,
    headerComponent: null,
    sections: getFormSections(),
    fields: getFormFields(allColumns, values),
    onAction: onAction,
    contentHeight: "auto",
    footerProps: footerProps,
    errors: errors
  }));
};
MultiSort.defaultProps = {
  onAction: _noop,
  values: EMPTY_OBJECT,
  errors: EMPTY_OBJECT,
  onClose: _noop,
  allColumns: []
};
MultiSort.propTypes = {
  onAction: PropTypes.func,
  allColumns: PropTypes.array,
  onClose: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object
};
export default withFormPageState(EMPTY_OBJECT, ACTION_HANDLERS)(MultiSort);